import React from "react";
import { Container, Typography, Box, Paper, Divider, List, ListItem, ListItemText } from "@mui/material";

export default function Datenschutz() {
    const hoster = {
        name: "Ionos",
        note: "IONOS",
    };

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: (t) => t.palette.grey[100], py: 6 }}>
            <Container maxWidth="md">
                <Paper elevation={3} sx={{ p: { xs: 3, md: 4 }, borderRadius: 2 }}>
                    <Typography variant="h4" sx={{ mb: 2, color: "primary.main" }}>
                        Datenschutzerklärung
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden auf dieser Website
                        nur im notwendigen Umfang verarbeitet. Diese Datenschutzerklärung informiert Sie darüber, welche Daten wir
                        verarbeiten, zu welchen Zwecken und welche Rechte Sie haben.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        1. Verantwortliche Stelle
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Gaststätte „Zum Alten Rathaus“<br />
                        Inhaberin: Mona Hartmann<br />
                        Wilhelmstr. 161<br />
                        42489 Wülfrath<br />
                        Telefon: 02058 – 1 79 86 87<br />
                        E-Mail: ZumAltenRathaus@gmx.de
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        2. Hosting / Bereitstellung der Website
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Diese Website wird bei einem externen Dienstleister gehostet:
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        <b>{hoster.name}</b><br />
                        <span style={{ opacity: 0.8 }}>{hoster.note}</span>
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Beim Besuch der Website werden durch den Hosting-Anbieter in der Regel sogenannte Server-Log-Dateien erhoben
                        (z. B. IP-Adresse, Zeitpunkt des Zugriffs, aufgerufene Seite, Browsertyp und Betriebssystem). Diese Daten sind
                        technisch erforderlich, um die Website korrekt auszuliefern sowie die Stabilität und Sicherheit zu gewährleisten.
                        <br /><br />
                        <b>Rechtsgrundlage:</b> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem und fehlerfreiem Betrieb).
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        3. Kontaktaufnahme (Telefon / E-Mail)
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden die von Ihnen mitgeteilten Daten (z. B. Name, Anliegen,
                        Kontaktdaten) zum Zweck der Bearbeitung Ihrer Anfrage verarbeitet. Wir geben diese Daten ohne Ihre Einwilligung
                        nicht an Dritte weiter.
                        <br /><br />
                        <b>Rechtsgrundlage:</b> Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Anbahnung) oder Art. 6 Abs. 1 lit. f DSGVO (Bearbeitung
                        allgemeiner Anfragen).
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        4. Externe Links (Instagram / Facebook)
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Auf dieser Website befinden sich Links zu externen Plattformen (z. B. Instagram und Facebook). Wenn Sie diese Links
                        anklicken, verlassen Sie unsere Website. Ab diesem Zeitpunkt ist der jeweilige Anbieter für die Datenverarbeitung
                        verantwortlich. Es kann dabei zu einer Übermittlung personenbezogener Daten (z. B. IP-Adresse) an den Anbieter kommen.
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        5. Google Maps
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Diese Website bindet Google Maps ein, um einen Lageplan darzustellen. Dabei kann es zur Übermittlung von Daten
                        (insbesondere IP-Adresse und ggf. Standortdaten – je nach Geräteeinstellungen) an Google kommen. Die Daten können
                        auch in Staaten außerhalb der EU verarbeitet werden.
                        <br /><br />
                        <b>Rechtsgrundlage:</b> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer nutzerfreundlichen Darstellung
                        des Standorts). Je nach Auslegung/Setup kann auch eine Einwilligung erforderlich sein (z. B. bei Einbindung mit
                        erweiterten Funktionen oder zusätzlichem Tracking).
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        6. Cookies / Analyse
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Diese Website setzt keine Analyse- oder Werbe-Tracking-Tools ein (sofern nicht separat ergänzt). Technisch notwendige
                        Cookies können je nach Hosting/Framework verwendet werden, um die grundlegende Funktionalität sicherzustellen.
                        Falls künftig Analyse-Tools oder Cookie-basierte Dienste eingesetzt werden, wird diese Datenschutzerklärung entsprechend
                        angepasst und – soweit erforderlich – eine Einwilligung eingeholt.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                        7. Ihre Rechte
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Sie haben im Rahmen der DSGVO insbesondere folgende Rechte:
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemText primary="Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO)" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="Berichtigung unrichtiger Daten (Art. 16 DSGVO)" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="Löschung Ihrer Daten (Art. 17 DSGVO)" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="Einschränkung der Verarbeitung (Art. 18 DSGVO)" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="Datenübertragbarkeit (Art. 20 DSGVO)" />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="Widerspruch gegen Verarbeitung auf Grundlage berechtigter Interessen (Art. 21 DSGVO)" />
                        </ListItem>
                    </List>

                    <Typography sx={{ mb: 2 }}>
                        Außerdem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.
                    </Typography>

                    <Typography sx={{ mt: 3 }} color="text.secondary" variant="body2">
                        Stand: {new Date().toLocaleDateString("de-DE")}
                    </Typography>
                </Paper>
            </Container>
        </Box>
    );
}
